export default {
  stopsMileageTextInput: 'bg-white rounded-md w-44!',
  stopsTrackingButton: 'bg-white! font-medium! hover:bg-white! text-black!',
};
